import type { SimpleChanges } from '@angular/core';
import { Component, output, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Location } from '@core/locations-types';
import {
  BadgeComponent,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import type { LocationsSectionTranslations } from '../locations-section.component';
import {
  LocationSectionTranslationsToken,
  LocationsSectionViewContext,
} from '../locations-section.component';

@Component({
  selector: 'rt-location-item',
  imports: [
    BadgeComponent,
    IconButtonComponent,
    GroupComponent,
    IconComponent,
    TranslatePipe,
    RtTooltip,
  ],
  templateUrl: './location-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./location-item.component.less'],
})
export class LocationItemComponent {
  public readonly translations = inject<LocationsSectionTranslations>(
    LocationSectionTranslationsToken,
  );

  public readonly location = input<Location>(undefined!);
  public readonly hasManageLocationsAbility = input<boolean>(undefined!);
  public readonly readOnly = input<boolean>(undefined!);
  public readonly langCode = input<string>(undefined!);
  public readonly viewContext = input<LocationsSectionViewContext>(undefined!);
  public unassign = output<number>();
  public edit = output<number>();

  public LocationsSectionViewContext = LocationsSectionViewContext;
  public locationFullAddress: string;

  public get isArchived() {
    return !!this.location().archivedAt;
  }

  public get isInvalid() {
    return !this.location().isValid;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.location) {
      this.locationFullAddress = this.getLocationFullAddress();
    }
  }

  public onUnassign() {
    this.unassign.emit(this.location().id);
  }

  public onEdit() {
    this.edit.emit(this.location().id);
  }

  private getLocationFullAddress() {
    const location = this.location();
    return (
      location.translations?.find(langTranslations => langTranslations.langCode === this.langCode())
        ?.fullAddress || location.fullAddress
    );
  }
}
